import { BG_CANVAS, COLOR_MUTED } from './blueprint-view-styles';

export const BlueprintLoadingSpinner = (): React.ReactElement => (
	<div style={{
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: BG_CANVAS
	}}>
		<style>{'@keyframes bp-spin { to { transform: rotate(360deg); } }'}</style>
		<div style={{ textAlign: 'center' }}>
			<div style={{
				width: '48px',
				height: '48px',
				border: '4px solid #ddd',
				borderTopColor: COLOR_MUTED,
				borderRadius: '50%',
				animation: 'bp-spin 0.8s linear infinite',
				margin: '0 auto 12px auto'
			}} />
			<div style={{ fontSize: '13px', color: COLOR_MUTED, fontFamily: "'Inter', sans-serif" }}>
				Loading Blueprint View...
			</div>
		</div>
	</div>
);
